// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"357c9e1d","453":"a9cf9532","732":"a4bb41c9","762":"5d976dcb","977":"15c80474"}[chunkId] + ".chunk.js";
};